import { put, takeEvery } from 'redux-saga/effects';
import { sendDiploma } from './api';
import { SEND_DIPLOMA } from './constants';
import { sendDiplomaSuccess } from './actions';

/**
 *
 * @param obj
 * @returns {IterableIterator<PutEffect<{result: *, type: string}>>}
 */
function* diplomaSend(obj){
    const serverResponse = yield sendDiploma(obj.form);
    if(serverResponse){
        yield put(sendDiplomaSuccess(serverResponse));
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchSendDiploma() {
    yield takeEvery(SEND_DIPLOMA,  diplomaSend);
}
export default watchSendDiploma;
